<template>
  <div id="app">
    <portal-target name="modal-destination" slim />
    <transition name="transition-1" mode="out-in">
      <RouterView />
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'App',

  data () {
    return {
      loaded: false
    }
  },

  computed: {
    ...mapState('auth', [
      'isSignIn',
      'userProfile'
    ])
  },

  methods: {
    ...mapMutations('auth', [
      'SET_IS_SIGN_IN',
      'SET_USER_PROFILE'
    ]),

    sessionValidate () {
      const requiresAuth = this.$route.matched.some(item => item.meta.requiresAuth)
      const isAdmin = this.$route.matched.some(item => item.meta.isAdmin)

      if (requiresAuth) {
        if (this.isSignIn) {
          this.userProfileRefresh()
        } else {
          this.$router.push({ name: 'login' })
        }
      } else if (this.isSignIn) {
        this.$router.push({ name: 'loggedVideos' })
      }
      if (isAdmin && !this.userProfile.roles.includes('ADMIN')) {
        alert('Acesso inválido')
        this.SET_IS_SIGN_IN(false)
        this.SET_USER_PROFILE(null)
        this.$router.replace({ name: 'login' })
      }
    },

    userProfileRefresh () {
      const userProfile = JSON.parse(sessionStorage.getItem('userProfile'))

      if (!this.userProfile) {
        this.SET_USER_PROFILE(userProfile)
      }
    }
  },

  watch: {
    $route () {
      this.sessionValidate()
    }
  },

  created () {
    if (this.$route.meta.requiresAuth && sessionStorage.getItem('isSignIn') === 'undefined') {
      this.$router.push({ name: 'login' })
      return
    }
    const isSignIn = JSON.parse(sessionStorage.getItem('isSignIn'))

    this.SET_IS_SIGN_IN(isSignIn)
    this.sessionValidate()
  }
}
</script>

<style lang="scss">
  @import '~@/styles/main.scss';
</style>
